import { combineReducers } from 'redux';
import { makeAsyncSelectors } from '../../../ui-lottery';
import facilities, { selectors as facilitiesSelectors } from './facilities';
import passTypes, { selectors as passTypesSelectors } from './passTypes';
import passType, { selectors as passTypeSelectors } from './passType';
import reservation, { selectors as reservationSelectors } from './reservation';

// Generate the async selectors
const { isLoaded, isLoading, hasErrors, getErrors } = makeAsyncSelectors('parkpass');

// All of our Redux selectors
export {
  isLoaded,
  isLoading,
  hasErrors,
  getErrors,
  facilitiesSelectors,
  reservationSelectors,
  passTypesSelectors,
  passTypeSelectors
};

const reducers = combineReducers({
  facilities,
  passTypes,
  passType,
  reservation
});

export default reducers;
